/**
 * Long Words Pack - 9-10 letter words
 * Combines words-9.ts and words-10.ts for challenging gameplay  
 */

import { WordPack } from '../../types/GameTypes';
import words9 from '../words-9';
import words10 from '../words-10';

const longWordsPack: WordPack = {
  id: 'long-words',
  name: 'Long Words (9-10 Letters)',
  description: 'Challenge yourself with longer, more complex words',
  difficulty: 'hard',
  words: [...words9, ...words10]
};

export default longWordsPack;